import Dropkick from 'dropkickjs'
import isMobile from 'ismobilejs'
import initValidation from './html5-validation'

const useNativeInputs = isMobile().any

if ('jQuery' in window) {
  // eslint-disable-next-line func-names
  window.jQuery.fn.globaljetCustomSingleSelect = function() {
    // eslint-disable-next-line func-names
    return this.each(function(index, element) {
      if (!useNativeInputs) {
        new Dropkick(element, {
          mobile: true,
          change: () => {
            const event = document.createEvent('Event')
            event.initEvent('input', true, true)
            element.dispatchEvent(event)
          },
        })
      }
      const wrapper = element.closest('.input-block')
      const wrapperParent = wrapper && wrapper.parentElement
      if (wrapperParent) {
        initValidation(wrapperParent)
      }
    })
  }
}
